///<reference path="BaseScreen.ts"/>
namespace nscs.screen {

    import MainScene = nscs.scene.MainScene;

    export class StorySlides extends BaseScreen {

        private static STORY_DATA:object = {
            1: [
                {
                    image:'story_1_1',
                    text:'cutscene0_1',
                    soundtrack:'soundtrackCS0'
                },
                {
                    image:'story_1_1',
                    text:'cutscene0_1B',
                    soundtrack:'soundtrackCS0'
                },
                {
                    image:'story_1_2',
                    text:'cutscene0_2',
                    soundtrack:'soundtrackCS0'
                },
                {
                    image:'story_1_3',
                    text:'cutscene0_3',
                    soundtrack:'soundtrackCS0'
                },
                {
                    image:'story_1_4',
                    text:'cutscene0_4',
                    soundtrack:'soundtrackCS0'
                },
                {
                    image:'story_1_5',
                    text:'cutscene0_5',
                    soundtrack:'soundtrackCS1'
                },
                {
                    image:'story_1_5',
                    text:'cutscene0_5B',
                    soundtrack:'soundtrackCS1'
                },
                {
                    image:'story_1_5',
                    text:'cutscene0_6',
                    soundtrack:'soundtrackCS1'
                },
                {
                    image:'story_1_6',
                    text:'cutscene0_7',
                    soundtrack:'soundtrackCS1'
                }
            ],
            2: [
                {
                    animationClass:'AnimationStory_2_1',
                    text:'cutscene1_1'
                },
                {
                    animationClass:'AnimationRunningCharacters_2',
                    nextSlideDelay: 15000
                },
                {
                    image:'story_2_2',
                    text:'cutscene1_2',
                    soundtrack:'soundtrackCS1'
                }
            ],
            3: [
                {
                    animationClass:'AnimationRunningCharacters_3',
                    nextSlideDelay: 13500
                },
                {
                    image:'story_3_1',
                    text:'',
                    soundtrack:'soundtrackCS1'
                },
                {
                    image:'story_3_2',
                    text:'',
                    soundtrack:'soundtrackCS1'
                },
                {
                    image:'story_3_3',
                    text:'cutscene2_3',
                    soundtrack:'soundtrackCS1'
                },
                {
                    image:'story_3_4',
                    text:'',
                    soundtrack:'soundtrackCS1'
                }
            ],
            4: [
                {
                    animationClass:'AnimationStory_4_1',
                    text:'cutscene3_1'
                },
                {
                    animationClass:'AnimationRunningCharacters_4',
                    nextSlideDelay: 11000
                },
                {
                    image:'story_4_2',
                    text:'cutscene3_2',
                    soundtrack:'soundtrackCS1'
                },
                {
                    image:'story_4_3',
                    text:'cutscene3_3',
                    soundtrack:'soundtrackCS1'
                },
                {
                    image:'story_4_3',
                    text:'cutscene3_3B',
                    soundtrack:'soundtrackCS1'
                },
                {
                    image:'story_4_4',
                    text:'cutscene3_4',
                    soundtrack:'soundtrackCS1'
                },
                {
                    image:'story_4_5',
                    text:'',
                    soundtrack:'soundtrackCS1'
                }
            ],
            5: [
                {
                    animationClass:'AnimationRunningCharacters_5',
                    nextSlideDelay: 12500
                },
                {
                    image:'story_5_1',
                    text:'cutscene4_1',
                    soundtrack:'soundtrackCS1'
                },
                {
                    image:'story_5_1',
                    text:'cutscene4_1B',
                    soundtrack:'soundtrackCS1'
                },
                {
                    image:'story_5_2',
                    text:'cutscene4_2',
                    soundtrack:'soundtrackCS1'
                }
            ],
            6: [
                {
                    animationClass:'AnimationStory_6_1',
                    nextSlideDelay: 33000,
                    soundtrack:'soundtrack6'
                },
                {
                    image:'story_6_3',
                    text:'',
                    soundtrack:'soundtrack6'
                },
            ]
        };

        slidesContainter:Phaser.GameObjects.Container;
        btnNext:Phaser.GameObjects.Image;
        btnPrev:Phaser.GameObjects.Image;
        text:Phaser.GameObjects.Text;
        slides:object[];

        slideIndex:number;
        slidesNum:number;

        textTyper:nscs.util.TextTyper;
        onComplete:()=>void;

        delayedCalls = [];

        private createGraphicsRect(color:number): Phaser.GameObjects.Graphics {
            let r = new Phaser.GameObjects.Graphics(this.scene);
            r.setPosition(0, 0);
            r.fillStyle(color, 1);
            r.fillRect(0, 0, game.scale.width, game.scale.height);
            return r;
        }

        constructor(scene:Phaser.Scene, storyIndex:number, onComplete:()=>void) {
            super(scene);

            this.add(this.createGraphicsRect(0x0));

            this.slidesContainter = new Phaser.GameObjects.Container(this.scene, 0, 0);
            this.add(this.slidesContainter);

            this.btnNext = new Phaser.GameObjects.Image(this.scene, 464-26, 303, 'stories', 'btn_change_slide'+'0000');
            this.add(this.btnNext);
            this.btnPrev = new Phaser.GameObjects.Image(this.scene, 464-26-22, 303, 'stories', 'btn_change_slide'+'0000');
            this.btnPrev.setScale(-1, 1);
            this.add(this.btnPrev);

            this.text = this.scene.add.text(15, 250, "", {
                "fontFamily": "Helvetica Rounded LT Black",
                "fontSize": 10,
                "color": "#FFFFFF",
                "align": 'left'
            });
            this.text.setWordWrapWidth(440);
            this.text.setOrigin(0, 0);
            this.add(this.text);

            this.textTyper = new nscs.util.TextTyper(this.scene, this.text, ()=>{
                this.delayedCalls.push(nscs.util.Functions.delayedCall(2000, ()=>this.showNextSlide()));
            });

            this.slides = StorySlides.STORY_DATA[storyIndex];
            this.slidesNum = StorySlides.STORY_DATA[storyIndex].length;
            this.slideIndex = -1;

            this.showNextSlide();

            let outAlpha:number = 0.65;
            this.btnNext.alpha = outAlpha;
            this.btnNext.setInteractive({cursor: 'pointer'});
            this.btnNext.on('pointerup', ()=>{
                this.showNextSlide();
            });
            this.btnNext.on('pointerover', ()=>{
                this.btnNext.alpha = 1;
            });
            this.btnNext.on('pointerout', ()=>{
                this.btnNext.alpha = outAlpha;
            });

            this.btnPrev.alpha = outAlpha;
            this.btnPrev.setInteractive({cursor: 'pointer'});
            this.btnPrev.on('pointerup', ()=>{
                this.showPrevSlide();
            });
            this.btnPrev.on('pointerover', ()=>{
                this.btnPrev.alpha = 1;
            });
            this.btnPrev.on('pointerout', ()=>{
                this.btnPrev.alpha = outAlpha;
            });

            this.onComplete = onComplete;
        }

        private showFgTransition(onComplete):void {
            let fg = this.createGraphicsRect(0x323232);
            MainScene.instance.children.add(fg);
            fg.alpha = 0;
            this.scene.tweens.add({
                targets: fg,
                'alpha': 1,
                duration: 1500,
                onComplete: ()=>{
                    this.visible = false;
                    MainScene.instance.children.remove(fg);
                    onComplete();
                }
            });

            fg.setScrollFactor(0);
        }

        private showNextSlide():void {
            if (this.slideIndex >= this.slidesNum - 1) {
                if (this.onComplete) {
                    nscs.sound.SoundManager.getInstance().fadeMusic(null, 1500);

                    this.showFgTransition(this.onComplete);

                    this.onComplete = null;
                }
                return;
            }


            this.slideIndex++;
            let slide;
            if (this.slidesContainter.length > this.slideIndex) {
                slide = this.slidesContainter.getAt(this.slideIndex) as Phaser.GameObjects.Image;
            } else {
                if (this.slides[this.slideIndex].hasOwnProperty('image')) {
                    slide = new Phaser.GameObjects.Container(this.scene);

                    let _slide = new Phaser.GameObjects.Image(this.scene, 0, 0, 'stories', this.slides[this.slideIndex]['image']+'0000');
                    _slide.setOrigin(0, 0);
                    _slide.setInteractive({cursor: 'pointer'});
                    _slide.on('pointerup', ()=>{
                        this.showNextSlide();
                    });

                    slide.add(this.createGraphicsRect(0x0));
                    slide.add(_slide);
                    slide["frame"] = {"name":_slide.frame.name};
                } else if (this.slides[this.slideIndex].hasOwnProperty('animationClass')) {
                    let animationClass:string = this.slides[this.slideIndex]['animationClass'];
                    if (animationClass == 'AnimationStory_6_1') {
                        slide = new stories.AnimationStory_6_1(this.scene);
                    } else if (animationClass == 'AnimationStory_6_2') {
                        slide = new stories.AnimationStory_6_2(this.scene);
                    } else if (animationClass == 'AnimationStory_2_1') {
                        slide = new stories.AnimationStory_2_1(this.scene);
                    } else if (animationClass == 'AnimationRunningCharacters_2') {
                        slide = new stories.AnimationRunningCharacters_2(this.scene);
                    } else if (animationClass == 'AnimationRunningCharacters_3') {
                        slide = new stories.AnimationRunningCharacters_3(this.scene);
                    } else if (animationClass == 'AnimationStory_4_1') {
                        slide = new stories.AnimationStory_4_1(this.scene);
                    } else if (animationClass == 'AnimationRunningCharacters_4') {
                        slide = new stories.AnimationRunningCharacters_4(this.scene);
                    } else if (animationClass == 'AnimationRunningCharacters_5') {
                        slide = new stories.AnimationRunningCharacters_5(this.scene);
                    }
                }
            }
            this.slidesContainter.add(slide);

            let prevSlide:Phaser.GameObjects.Image = null;
            if (this.slideIndex - 1 >= 0) {
                prevSlide = this.slidesContainter.getAt(this.slideIndex - 1) as Phaser.GameObjects.Image;
                if (prevSlide.frame.name != slide.frame.name) {
                    /*this.scene.tweens.add({
                        targets: prevSlide,
                        'alpha': 0,
                        duration: 500
                    });*/
                } else {
                    this.scene.tweens.killTweensOf(prevSlide);
                    prevSlide.alpha = 0;
                }
            }

            if (!prevSlide || prevSlide.frame.name != slide.frame.name) {
                /*slide.alpha = 0;
                this.scene.tweens.add({
                    targets: slide,
                    'alpha': 1,
                    duration: 500
                });*/
            } else {
                this.scene.tweens.killTweensOf(slide);
                slide.alpha = 1;
            }

            if (this.slides[this.slideIndex].hasOwnProperty('text')) {
                this.typeText();
            } else {
                this.text.setText("");
            }

            this.refreshButtonsNextPrev();

            if (this.slides[this.slideIndex].hasOwnProperty('nextSlideDelay')) {
                nscs.util.Functions.delayedCall(this.slides[this.slideIndex]["nextSlideDelay"], ()=>{
                    this.showNextSlide();
                });
            }

            if (this.slides[this.slideIndex]['soundtrack']) {
                nscs.sound.SoundManager.getInstance().fadeMusic(this.slides[this.slideIndex]['soundtrack'], 500, true);
            }
        }

        private refreshButtonsNextPrev():void {
            if (this.slides[this.slideIndex].hasOwnProperty('animationClass')) {
                this.btnNext.visible = this.btnPrev.visible = false;
            } else {
                this.btnNext.visible = true;
                this.btnPrev.visible = this.slideIndex > 0 && !this.slides[this.slideIndex-1].hasOwnProperty('animationClass');
            }
        }

        public typeText():void {
            this.textTyper.typeText(nscs.gameplay.Gameplay.getText(this.slides[this.slideIndex]['text']));
        }

        private showPrevSlide():void {
            let currSlide:Phaser.GameObjects.Image = this.slidesContainter.getAt(this.slideIndex) as Phaser.GameObjects.Image;
            if (this.slideIndex < 1) {
                this.typeText();
                return;
            }
            this.slideIndex--;

            let prevSlide:Phaser.GameObjects.Image = this.slidesContainter.getAt(this.slideIndex) as Phaser.GameObjects.Image;

            if (prevSlide.frame.name != currSlide.frame.name) {
                /*this.scene.tweens.add({
                    targets: prevSlide,
                    'alpha': 1,
                    duration: 500
                });*/
                prevSlide.alpha = 1;
                /*this.scene.tweens.add({
                    targets: currSlide,
                    'alpha': 0,
                    duration: 500
                });*/
                currSlide.alpha = 0;
            } else {
                prevSlide.alpha = 1;
                currSlide.alpha = 0;
            }

            if (this.slides[this.slideIndex].hasOwnProperty('text')) {
                this.typeText();
            } else {
                this.text.setText("");
            }

            this.refreshButtonsNextPrev();
        }

        public destroy(fromScene?: boolean): void {
            for (let dc of this.delayedCalls) {
                nscs.util.Functions.destroyDelayedCall(dc);
            }
            this.delayedCalls = [];

            this.textTyper.stop();

            super.destroy(fromScene);
        }

        public updateScreen(): void {
            super.updateScreen();

            if (nscs.scene.MainScene.instance.inputController.escPressedDownAndReleased()) {
                nscs.scene.MainScene.instance.inputController.escPressUsed();
                nscs.scene.MainScene.instance.switchScreen(new nscs.screen.ChooseCharacterScreen(this.scene));
                nscs.sound.SoundManager.getInstance().fadeMusic(null, 500);
            } else if (nscs.scene.MainScene.instance.inputController.upPressedDownAndReleased()) {
                nscs.scene.MainScene.instance.inputController.upPressUsed();
                this.showNextSlide();
            }
        }
    }
}
